<div class="chat-widget">
  <a href="https://wa.me/919871268882" target="_blank" class="chat-link">
    <i class="bi bi-whatsapp"></i>
    <span class="chat-text">Have Questions? Chat with Us!</span>
  </a>
</div>
